import { IExplicitValidationFnDescription } from "@multiweb/reactControls";

/**
 * Vrací lokalizační klíče uřčené pro načtení v rámci {@link ValidationErrorWrapper}.
 * - To jsou všechny lokalizační klíče se zadaných `explicitValidationFnDescriptions`.
 * @param explicitValidationFnDescriptions
 */
export const getLocKeysToLoad = (explicitValidationFnDescriptions: ReadonlyArray<IExplicitValidationFnDescription>) => (
    explicitValidationFnDescriptions.map(({ locKey }) => locKey)
);
